import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, of } from 'rxjs';
import { StorageService } from 'src/app/_services/storage.service';
import { environment } from 'src/environments/environment';
const { API_URLBLAZE } = environment;

@Injectable({
  providedIn: 'root'
})
export class DocumentUploadService {

  constructor(private http: HttpClient, private storageService: StorageService, private router: Router) { }

  signWithUaePass(id: any) {
    var url = `${API_URLBLAZE}/uaepass/merchant-sign-in?id=${id}`;
    return this.http.get(url).pipe(catchError(this.handleError()));
  }

    getUBO(userId:any) {
    return this.http.get(`${API_URLBLAZE}/user/merchant/getUBO/${userId}`);
  }

  getDocumentList(filterData: any, pageSize: any, pageNumber: number) {
    var url = "";
    var filter = "";
    if (filterData != null) {
      if (filterData['merchantEmail'] != "" && filterData['merchantEmail'] != undefined) {
        filter = filter + `&merchantEmail=${filterData['merchantEmail']}`
      }
      if (filterData['documentType'] != "" && filterData['documentType'] != undefined) {
        filter = filter + `&documentType=${filterData['documentType']}`
      }
      if (filterData['merchantName'] != "" && filterData['merchantName'] != undefined) {
        filter = filter + `&merchantName=${filterData['merchantName']}`
      }
      if (filterData['uploadedBy'] != "" && filterData['uploadedBy'] != null) {
        filter = filter + `&uploadedBy=${filterData['uploadedBy']}`
      }

      if(filterData['signedCompletionDate'] != null && filterData['signedCompletionDate'] != ""){
        filter = filter+`&signedCompletionDate=gte%3D${filterData['signedCompletionDate']} 00:00:00%24lte%3D${filterData['signedCompletionDate']} 23:59:59`
      }

      if(filterData['uploadedDate'] != null && filterData['uploadedDate'] != ""){
        filter = filter+`&uploadedDate=gte%3D${filterData['uploadedDate']} 00:00:00%24lte%3D${filterData['uploadedDate']} 23:59:59`
      }


      // filter = filter+`&sort_dir=DESC`
      // filter = filter+`&sort_column=createdDate`
      // url = `${API_URLBLAZE}/user/customer/customerList?page_size=${page_size}&page_no=${page_no}&userType=$in=CUSTOMER`+filter;
      // console.log(url);
      // return this.http.get(url).pipe(catchError(this.handleError()));
    }

    var url = '';

    if (filter != '') {
      url = `${API_URLBLAZE}/uaepass/fetch-merchant-details?page_size=${pageSize}&page_no=${pageNumber}&sort_dir=DESC&sort_column=uploadedDate` + filter;
    } else {
      url = `${API_URLBLAZE}/uaepass/fetch-merchant-details?page_size=${pageSize}&page_no=${pageNumber}&sort_dir=DESC&sort_column=uploadedDate`;
    }
    console.log(url);
    return this.http.get(url).pipe(catchError(this.handleError()));
  }

  downloadDocument(docPath: any) {
    var url = `${API_URLBLAZE}/uaepass/download-merchant-doc?url=${docPath}`;
    return this.http.get(url, { responseType: 'blob' as 'json' }).pipe(catchError(this.handleError()));
  }

  deleteUnsignedDocument(docId: any) {
    var url = `${API_URLBLAZE}/uaepass/delete-unsigned-document?id=${docId}`;
    return this.http.get(url);
  }

  getDocument(docPath: any): Observable<Blob> {
    var url = `${API_URLBLAZE}/uaepass/download-merchant-doc?url=${docPath}`;
    return this.http.get(url, { responseType: 'blob' });
    // return this.http.get(url).pipe(catchError(this.handleError()));
  }

  fetchMerchantRecord(id: any,csrf: any) {
    var url = `${API_URLBLAZE}/uaepass/fetch-merchant-data?id=${id}&csrf_token=${csrf}`;
    return this.http.get(url).pipe(catchError(this.handleError()));
  }

  uploadDocument(doc: any) {
    var url = "";
    url = `${API_URLBLAZE}/uaepass/upload-doc`;
    return this.http.post(url, doc).pipe(catchError(this.handleError()));
    // return this.http.get(url).pipe(catchError(this.handleError()));
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: HttpErrorResponse): Observable<T> => {
      if (error.status == 401) {
        this.storageService.clean()
        this.router.navigate(['/auth/login']);
      }
      result = error?.error;
      return of(result as T);
    };
  }

}
